// extracted by mini-css-extract-plugin
export default {"Inline":"Popover_Inline__udsDb","Badge":"Popover_Badge__pTg96"};